export enum ConditionTypeEnum {
  VisibleIfAnswerIsTruly = 'visibleIfAnswerIsTruly',
  VisibleIfAnswerIsFalsy = 'visibleIfAnswerIsFalsy',
  VisibleIfAnswerHasValue = 'visibleIfAnswerHasValue'
}
